import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import { PageTitleService } from '@rd/core/services/page-title/page-title.service';
import { AnzAnalyticsService } from '../../services/analytics/analytics.service';

@Component({
  selector: 'rd-anz-gift-card-unavailable',
  templateUrl: './gift-card-unavailable.component.html',
  styleUrls: ['./gift-card-unavailable.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AnzGiftCardUnavailableComponent implements OnInit {
  @HostBinding('class.rd-anz-gift-card-unavailable') componentClass = true;

  constructor(
    private anzAnalyticsService: AnzAnalyticsService,
    private pageTitleService: PageTitleService,
  ) {}

  ngOnInit(): void {
    this.pageTitleService.setPageTitle('gift-card-unavailable');
    this.anzAnalyticsService.track({
      routeName: this.anzAnalyticsService.sitemap.giftCardUnavailable,
    });
  }
}
